import { gql } from '@apollo/client';

const UPDATE_STUDY_INTERPETING_PHYSICIAN = gql`
  mutation updateStudyInterprettingPhysician($input: UpdateStudyInterprettingPhysicianInput!) {
    updateStudyInterprettingPhysician(input: $input) {
      message
      isSuccess
      study {
        info {
          interprettingPhysician {
            id
            firstName
            lastName
            contact {
              phone1
              nightPhone
              fax
              country
            }
            email
            npi
          }
        }
      }
    }
  }
`;

export default UPDATE_STUDY_INTERPETING_PHYSICIAN;
